var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { defaultOptionList } from './defaults';
import { DivTag } from '../../Utils/AtomicTag';
import CacheMap from './setMap';
import { filterOptions } from './util';
import { CheckMarkFunc } from '@feb-team/legao-icons-react';
var KeyCode = {
    UP: 38,
    DOWN: 40,
    ENTER: 13,
    ESC: 27,
};
var OptionList = /** @class */ (function (_super) {
    __extends(OptionList, _super);
    function OptionList(props) {
        var _this = _super.call(this, props) || this;
        _this.setActiveIndex = function (nextProps) {
            var values = nextProps.values;
            var value = Array.from(values)[0];
            var index = _this.state.displayOptions.findIndex(function (option) { return value === option.value; });
            _this.setState({
                activeIndex: index,
            });
            _this.scrollIntoView(index);
        };
        _this.createCacheMap = function () {
            var _a;
            var cacheMap = new CacheMap();
            (_a = _this.state.listRef.current) === null || _a === void 0 ? void 0 : _a.childNodes.forEach(function (itemElement, key) {
                var offsetHeight = itemElement.offsetHeight;
                if (cacheMap.get(key) !== offsetHeight) {
                    cacheMap.set(key, offsetHeight);
                }
            });
            _this.setState({
                cacheMap: cacheMap,
            });
        };
        _this.handerMouseDown = function (e) {
            if (_this.state.mouseOver) {
                e.preventDefault();
            }
        };
        _this.handleMouseEnter = function () {
            _this.setState({
                mouseOver: true,
            });
        };
        _this.handleMouseLeave = function () {
            _this.setState({
                mouseOver: false,
            });
        };
        /** 获取可以选中的项 */
        _this.getEnabledActiveIndex = function (index, offset) {
            if (offset === void 0) { offset = 1; }
            var len = _this.state.displayOptions.length;
            for (var i = 0; i < len; i += 1) {
                var current = (index + i * offset + len) % len;
                var _a = _this.state.displayOptions[current], disabled = _a.disabled, options = _a.options;
                if (!disabled && !options) {
                    return current;
                }
            }
            return -1;
        };
        /** 键盘操作 */
        _this.onKeyDown = function (e) {
            var _a = _this.state, activeIndex = _a.activeIndex, displayOptions = _a.displayOptions;
            switch (e.which) {
                // >>> Arrow keys
                case KeyCode.UP:
                case KeyCode.DOWN: {
                    var offset = 0;
                    if (e.which === KeyCode.UP) {
                        offset = -1;
                    }
                    else if (e.which === KeyCode.DOWN) {
                        offset = 1;
                    }
                    var nextActiveIndex = _this.getEnabledActiveIndex(activeIndex + offset, offset);
                    _this.setState({
                        activeIndex: nextActiveIndex,
                    });
                    _this.scrollIntoView(nextActiveIndex);
                    break;
                }
                // >>> Select
                case KeyCode.ENTER: {
                    var item = displayOptions[activeIndex];
                    if (item && !item.disabled) {
                        _this.props.selectOption(e, item);
                    }
                    break;
                }
            }
        };
        /**
         * options 列表滚动 区分目标item的顶部 itemTop 和底部 itemBottom
         */
        _this.scrollIntoView = function (nextIndex) {
            if (nextIndex === void 0) { nextIndex = 0; }
            var _a = _this.state, listRef = _a.listRef, cacheMap = _a.cacheMap;
            _this.createCacheMap();
            if (listRef.current && Object.keys(cacheMap).length > 0) {
                var height = listRef.current.clientHeight;
                var stackTop = 0;
                var itemTop = 0;
                var itemBottom = 0;
                for (var i = 0; i <= nextIndex; i++) {
                    itemTop = stackTop;
                    itemBottom = itemTop + cacheMap.get(i);
                    stackTop = itemBottom;
                }
                var scrollTop = listRef.current.scrollTop;
                var scrollBottom = scrollTop + height;
                if (itemTop < scrollTop) {
                    // scroll to top
                    listRef.current.scrollTo(0, 0);
                }
                else if (itemBottom > scrollBottom) {
                    // scroll to bottom
                    listRef.current.scrollTo(0, itemBottom - height);
                }
            }
        };
        _this.selectItemOption = function (e, item) {
            if (item && !item.disabled) {
                _this.props.selectOption(e, item);
            }
        };
        _this.renderItem = function (item, index) {
            var key = item.key, disabled = item.disabled, value = item.value, parent = item.parent, options = item.options, children = item.children, rest = __rest(item, ["key", "disabled", "value", "parent", "options", "children"]);
            var _a = _this.state, activeIndex = _a.activeIndex, instanceRef = _a.instanceRef;
            var itemCls = [
                'py-px-5',
                parent ? 'px-px-20' : 'px-px-12',
                'truncate',
                'relative',
            ];
            var labelCls = [
                'text-xs',
                'text-gray-600',
                'py-px-5',
                'px-px-12',
                'cursor-default',
            ];
            if (disabled) {
                itemCls = itemCls.concat(['text-gray-400', 'cursor-not-allowed']);
            }
            else if (_this.props.values.has(value)) {
                itemCls = itemCls.concat(['text-brand-600', 'font-bold', 'cursor-pointer']);
            }
            else if (activeIndex == index) {
                itemCls = itemCls.concat(['bg-gray-100', 'cursor-pointer']);
            }
            var label = item.label ? item.label : item.value;
            var selectIconCls;
            if (_this.props.values.has(value)) {
                selectIconCls = ['absolute', 'right-0', 'top-half', 'pr-px-12', '-mt-px-7', 'flex'];
            }
            else {
                selectIconCls = ['hidden'];
            }
            return options ? (React.createElement(DivTag, { key: index, atomics: labelCls, autoPrefixedClassName: "autocomplete-option" }, item.label)) : (React.createElement(DivTag, __assign({ key: key ? key : index, ref: instanceRef, atomics: itemCls, onClick: function (e) { return _this.selectItemOption(e, item); }, onMouseEnter: function () {
                    if (activeIndex == index || disabled) {
                        return;
                    }
                    _this.setState({
                        activeIndex: index,
                    });
                } }, rest),
                children ? children : label,
                item.label ? null : (React.createElement(DivTag, { atomics: selectIconCls },
                    React.createElement(CheckMarkFunc, { className: 'w-4' })))));
        };
        _this.state = {
            activeIndex: -1,
            cacheMap: {},
            mouseOver: false,
            displayOptions: [],
            listRef: React.createRef(),
            instanceRef: React.createRef(),
        };
        return _this;
    }
    OptionList.prototype.componentWillReceiveProps = function (nextProps) {
        var options = nextProps.options, values = nextProps.values, nextOpen = nextProps.open;
        var _a = this.props, filterOption = _a.filterOption, open = _a.open;
        // 打开选择列表时，进行数据过滤
        if (nextProps.open) {
            var filteredOptions = filterOptions(Array.from(values)[0], this.normalization([], options), filterOption === undefined ? function () { return true; } : filterOption);
            this.setState({
                displayOptions: filteredOptions,
            });
        }
        else {
            this.setState({
                mouseOver: false,
            });
        }
        // keydown 事件绑定
        if (nextOpen !== open) {
            if (nextOpen) {
                document.addEventListener('keydown', this.onKeyDown, false);
            }
            else {
                document.removeEventListener('keydown', this.onKeyDown);
            }
        }
        this.setActiveIndex(nextProps);
    };
    /**
     * 将 options 标准化
     * @param normalOption
     * @param margeOption
     */
    OptionList.prototype.normalization = function (normalOption, margeOption, parent) {
        var _this = this;
        margeOption.forEach(function (item, index) {
            if (parent) {
                item.parent = true;
            }
            normalOption.push(item);
            if (item.options) {
                _this.normalization(normalOption, item.options, true);
            }
        });
        return normalOption;
    };
    OptionList.prototype.render = function () {
        var _this = this;
        var _a = this.props, dropdownClassName = _a.dropdownClassName, open = _a.open;
        var _b = this.state, displayOptions = _b.displayOptions, listRef = _b.listRef;
        var contextCls = [
            'absolute',
            'shadow-lg',
            'mt-px-37',
            'top-0',
            'left-0',
            'z-50',
            'w-full',
            'transition-all',
            'duration-200',
            'ease-base-in',
            'rounded',
        ];
        var optionsCls = [
            'bg-white',
            'text-sm',
            'max-h-px-256',
            'overflow-y-auto',
            'rounded',
        ];
        var contextStyle = {
            opacity: open && displayOptions.length > 0 ? 1 : 0,
            transform: "scaleY(" + (open && displayOptions.length > 0 ? 1 : 0) + ")",
            transformOrigin: "0% 0%",
        };
        return (React.createElement(DivTag, { atomics: contextCls, className: dropdownClassName, style: contextStyle, onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave, onMouseDown: function (e) { return _this.handerMouseDown(e); }, autoPrefixedClassName: "autocomplete-option-list" },
            React.createElement(DivTag, { atomics: optionsCls, ref: listRef, autoPrefixedClassName: "autocomplete-option-list-contain" }, displayOptions.map(function (item, index) {
                return _this.renderItem(item, index);
            }))));
    };
    OptionList.defaultProps = defaultOptionList;
    return OptionList;
}(React.PureComponent));
export { OptionList };
